import Vue from 'vue';
import Vuex from 'vuex';
import Api from '../../services/Api';

Vue.use(Vuex);

const getters = {
  activePlan: state => state.activePlan,
  activePlanCharges: state => state.activePlanCharges,
  pricing: state => state.pricing,
  plansLoaded: state => state.plansLoaded,
  userSubscription: state => state.userSubscription,
};

const mutations = {
  setActivePlan: (state, activePlan) => { state.activePlan = activePlan; },
  setActivePlanCharges: (state, activePlanCharges) => { state.activePlanCharges = activePlanCharges; },
  setPricing: (state, pricing) => { state.pricing = pricing; },
  setPlansLoaded: (state, plansLoaded) => { state.plansLoaded = plansLoaded; },
  setUserSubscription: (state, userSubscription) => { state.userSubscription = userSubscription; },
};

const state = {
  activePlan: null,
  activePlanCharges: null,
  pricing: { currency: 'USD', price: 7.99 },
  plansLoaded: false,
  userSubscription: null,
};

const actions = {
  setActivePlan: (context, activePlan) => {
    context.commit('setActivePlan', activePlan);
  },
  fetchAvailablePricingPlans: (context) => {
    const apiProvider = new Api();
    apiProvider.getList('/zuora/products?product_type={product_type}', { product_type: 'WebStore' }).then((resp) => {
      let plan = null;
      if (resp && resp.success) {
        resp.products.forEach((product) => {
          product.productRatePlans.forEach((ratePlan) => {
            if (ratePlan.status === 'Active') {
              plan = ratePlan;
            }
          });
        });
      }
      context.commit('setActivePlan', plan);
      context.commit('setActivePlanCharges', plan.productRatePlanCharges[0]);
      context.commit('setPlansLoaded', true);
    }).catch(() => {
      context.commit('setPlansLoaded', true);
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./app/src/store/modules/subscription.js